import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./FAQ.css";
import { useDispatch, useSelector } from "react-redux";
import { addFAQ } from "../../Redux/Actions/faqsAction";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { useNavigate } from "react-router-dom";

const AddFAQ = () => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [page, setPage] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Select enumsData from Redux store
  const { enumsData = {} } = useSelector((state) => state.enumsData || {});

  // Fetch enums on mount
  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  const handleBackClick = () => {
    navigate("/faq");
  };

  const handleFAQSubmit = () => {
    if (!page || !question || !answer) {
      alert("Please fill all fields");
      return;
    }
    dispatch(
      addFAQ({
        page: page,
        question: question,
        answer: answer,
      })
    );
    // Clear form fields after submission
    setPage("");
    setAnswer("");
    setQuestion("");
  };

  return (
    <MainLayout>
      <div className="faq_table_container">
        <div className="faq-first-row">
          <h1>Add FAQ</h1>
          <button className="add_pages_button" onClick={handleBackClick}>
            View FAQ list
          </button>
        </div>
        <div className="faq-form">
          <div style={{ marginLeft: "20px" }}>
            <span className="span-class">Page</span>
            <select
              value={page}
              onChange={(e) => setPage(e.target.value)}
              name="for"
              id="pageSelect"
              className="input-class"
            >
              <option value="" disabled>
                Select an Option
              </option>
              {enumsData?.data?.pageName ? (
                Object.entries(enumsData.data.pageName).map(([key, value]) => (
                  <option key={key} value={value}>
                    {key}
                  </option>
                ))
              ) : (
                <option disabled>Loading options...</option>
              )}
            </select>
          </div>
          <div style={{ marginLeft: "20px", marginTop: "10px" }}>
            <label htmlFor="question" className="span-class">
              Enter Question:
            </label>
            <textarea
              id="question"
              name="Question"
              className="input-class"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              rows="4"
              placeholder="Type your Question here..."
            />
          </div>
          <div style={{ marginLeft: "20px", marginTop: "10px" }}>
            <label htmlFor="answer" className="span-class">
              Enter Answer:
            </label>
            <textarea
              id="answer"
              name="Answer"
              className="input-class"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              rows="4"
              placeholder="Type your Answer here..."
            />
          </div>
          <button className="add_pages_button" onClick={handleFAQSubmit}>
            Submit
          </button>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddFAQ;
